module.exports = __webpack_public_path__ + "img/VIA-Planner-White.3420100b.png";